import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Label } from 'semantic-ui-react'
import ReactPDF, { Page, Text, View, Document, StyleSheet, Image, Font, PDFDownloadLink, Svg } from '@react-pdf/renderer';
import axios from 'axios';
import './style.css';
import {
  Card,
  Table,
  Button,
  Checkbox,
  Stack,
  Paper,
  Avatar,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  FormControl,
  TextField
} from '@mui/material';
import { Link } from 'react-router-dom';

export default function Update(props) {
	
	const navigate  = useNavigate();
	
	const [id, setId] = useState(localStorage.getItem('id'));	
	const [deviceId, setDeviceId] = useState('');
	const [subscriberId, setSubscriberId] = useState('0');
		
	const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;
	
	useEffect(() => {
		setId(localStorage.getItem('id'));
		setDeviceId(localStorage.getItem('deviceId'));
        setSubscriberId(localStorage.getItem('subscriberId'));	
	}, []);
			
	const postData = () => {		
		axios.post("https://gpsdogstracking.com/api/devices/",
		{
		"id": 3,
		"subscriberId": subscriberId,
        "ime": "Jedan",
		"tip": "ker_posavski_gonic",
        "IMEI": "1",
        "tiptrackera": "HunterGPS",
        "brojmobitela": "000000000",
        "aktivan": 0,
        "bojaputanje": "Plavo-Crvena",
        "baterija": "0.00",
        "online": 0,
        "onlinetoday": 0,
        "uploadinterval": 30,
        "needreset": 0,
		"workmode": 1,
        "blokiran": 0,
        "setuploadinterval": 0,
        "needdisconnect": 0,
        "saldo": -1,
        "voucher": "0",
        "datumstart": "2021-09-01",
        "datumend": "2020-09-01",
        "datumlast": "2021-09-01",
        "brojlokacija": 0,
        "createdAt": "2023-07-11T12:35:00.000Z",
        "updatedAt": "2023-07-12T05:58:34.000Z"
		}
		).then(() => {
            navigate('/dashboard/SharedDevices')
        });
		
		//navigate('/dashboard/SharedDevices')
	}
		
    return (
		<Container maxWidth="xl">
	    <Typography variant="subtitle2" noWrap>
			Dodjeljivanje uređaja
		</Typography>
        <Card>
		  
		    <TableContainer sx={{ minWidth: 1000 }}>
			
              <Table>
			  
                <TableBody>
        
                <TableRow>					
					<TableCell component="th" scope="row" >
						<Label>Device</Label>
							<TextField
							required
							defaultValue=""
							value={deviceId}
							onChange={(e) => setDeviceId(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							},
							}}
							/>
                    </TableCell>

                    <TableCell component="th" scope="row" >
						<Label>Subscriber</Label>
							<TextField
							required
							defaultValue=""
							value={subscriberId}
							onChange={(e) => setSubscriberId(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							},
							}}
							/>
                    </TableCell>						
                </TableRow>

                <TableRow>
                    <TableCell component="th" scope="row" >
						<Button onClick={postData} type='submit'>Spasi</Button>
                     </TableCell>			
                </TableRow>
				
                </TableBody>
				
              </Table>
			  
            </TableContainer>
			
        </Card>
        </Container>
    )
}